function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-62.000000, -103.000000)",
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(62.000000, 103.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,14.9230769 L18,18.1538462 L2,18.1538462 L2,14.9230769 C2,14.4126154 1.552,14 1,14 C0.447,14 0,14.4126154 0,14.9230769 L0,19.0769231 C0,19.5864615 0.447,20 1,20 L19,20 C19.552,20 20,19.5864615 20,19.0769231 L20,14.9230769 C20,14.4126154 19.552,14 19,14 C18.447,14 18,14.4126154 18,14.9230769 Z",
  id: "Fill-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7323692,8.44840713 L13.7323692,0.472373119 C13.7323692,0.212567904 13.5233168,0 13.2657344,0 L6.73284732,0 C6.47619819,0 6.26621253,0.212567904 6.26621253,0.472373119 L6.26621253,8.44746238 L3.46640378,8.44746238 C3.05576516,8.44746238 2.8429797,8.95573586 3.13602635,9.25427567 L9.66891343,15.8674993 C9.84436812,16.0441669 10.1542136,16.0441669 10.3296683,15.8674993 L16.8625554,9.25427567 C17.1574686,8.95573586 16.9456164,8.44746238 16.532178,8.44746238 L13.7323692,8.44840713 Z",
  id: "Fill-1"
})))));

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.84f1356c.svg";
export { ForwardRef as ReactComponent };